<template>
  <div className="announcements-page">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'announcements-page',
}

</script>
